module.exports = ".username {\n  font-size: 14px; }\n\n.email, .username {\n  display: block;\n  text-align: right; }\n\n.email {\n  color: #808080; }\n\n.navbar-nav > li > a {\n  text-shadow: none; }\n\n.dropdown-menu > li {\n  cursor: pointer; }\n\n.user-details-section {\n  position: absolute;\n  right: 0; }\n\n.profile-component {\n  display: table-cell;\n  height: 50px;\n  padding: 5px;\n  vertical-align: middle;\n  line-height: 1.25em; }\n\n.brand a:hover, .brand a:focus {\n  text-decoration: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/components/header.component.scss
// module id = ./src/app/header/components/header.component.scss
// module chunks = main